import React from 'react';

import { ProductHero } from '@/app/_components/ProductHero';
import { ProductHeroProps } from './types';

import classes from './index.module.scss';

export const ProductHeroGraphQL: React.FC<ProductHeroProps> = props => {
  const { id } = props;

  return (
    <div id={`block-${id}`} className={classes.blockWrapper}>
      <ProductHero productHero={props} />
    </div>
  );
};

export default ProductHeroGraphQL;
